module.exports = __webpack_public_path__ + "img/ekyc_frame_square.551174ea.svg";